const map = {
  businessInformationLevel1: 55625,
  businessInformationLevel2: 55667,
  financeLevel1: 55626,
  financeLevel2: 55668,
  staffingLevel1: 55627,
  staffingLevel2: 55670,
  marketingLevel1: 55628,
  marketingLevel2: 55669,
  operationalManagement: 55629,
  informationTechnologyLevel1: 55630,
  informationTechnologyLevel2: 55672,
  mentorshipSession: 55632,
};

export default map;
